import Layout from '@/components/layout/Layout';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * On-brand Suspense fallback for heritage CMS routes.
 *
 * Shows the Y.O. Ranch word-mark with a warm brass shimmer and a
 * heritage-appropriate skeleton layout while the ~22 KB chunk loads.
 */
const HeritageFallback = () => (
  <Layout>
    <section className="py-20 lg:py-28 bg-gradient-to-b from-secondary/30 to-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center space-y-5">
          {/* Brand mark with brass shimmer */}
          <div className="flex items-center justify-center gap-3">
            <div className="h-px w-12 bg-gradient-to-r from-transparent via-accent/60 to-transparent" />
            <span
              className="font-serif text-2xl tracking-widest text-primary/90 animate-pulse"
              aria-hidden="true"
            >
              Y.O.
            </span>
            <div className="h-px w-12 bg-gradient-to-r from-transparent via-accent/60 to-transparent" />
          </div>

          <Skeleton className="h-12 sm:h-14 w-3/4 mx-auto max-w-xl" />

          <div className="divider-brass" />

          <Skeleton className="h-4 w-full max-w-xl mx-auto" />
          <Skeleton className="h-4 w-5/6 max-w-lg mx-auto" />
        </div>
      </div>
    </section>

    <section className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {Array.from({ length: 6 }).map((_, i) => (
            <div
              key={i}
              className="bg-card border border-border overflow-hidden"
              aria-hidden="true"
            >
              <Skeleton className="h-52 w-full rounded-none" />
              <div className="p-5 space-y-3">
                <Skeleton className="h-3 w-20" />
                <Skeleton className="h-5 w-3/4" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-5/6" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <span className="sr-only" role="status" aria-live="polite">
      Loading Y.O. Ranch Heritage content…
    </span>
  </Layout>
);

export default HeritageFallback;
